import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const masterDataItemService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/master-data-item/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/master-data-item/' + id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/master-data-item', data )
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/master-data-item/${data.id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/master-data-item/${id}`)
    return response.data
  },
}